import AuthService from "../../utilities/services/auth.service";

import { ModalProvider } from "../../providers/ModalProvider/ModalProvider";
import { ARAgingSummaryWrapper } from "../../components";

export default function ARAgingSummaryPage() {
  const organization = AuthService.getOrg()[0];

  return (
    <ModalProvider>
      <ARAgingSummaryWrapper organization={organization} />
    </ModalProvider>
  );
}
